import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

function RoleRoute({ allowedRoles, children }) {
  const { hasRole, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }
  
  const hasAccess = allowedRoles.some(role => hasRole(role))
  
  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />
  }
  
  return children ? <>{children}</> : <Outlet />
}

export default RoleRoute